import PropTypes from "prop-types";
import React from "react";
import { Menu, Container } from "semantic-ui-react";

const FormsTabNavigation = ({ sections, activeTab, setActiveTab }) => {
  const handleTabClick = (index, section) => {
    setActiveTab(index);

    if (section.onClick) {
      section.onClick();
    }
  };

  return (
    <Container>
      <Menu pointing secondary style={{ marginBottom: 0 }}>
        {sections.map((section, index) => (
          <Menu.Item
            key={index}
            name={section.label}
            active={activeTab === index}
            onClick={() => handleTabClick(index, section)}
            style={{
              cursor: "pointer",
              fontWeight: activeTab === index ? "bold" : "normal",
              color: activeTab === index ? "#2185d0" : "#767676",
              borderBottom: activeTab === index ? "2px solid #2185d0" : "none",
              paddingBottom: "10px",
              transition: "all 0.2s ease",
            }}
          >
            {section.label}
          </Menu.Item>
        ))}
      </Menu>
    </Container>
  );
};

FormsTabNavigation.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      targetId: PropTypes.string,
      onClick: PropTypes.func,
    })
  ).isRequired,
  activeTab: PropTypes.number.isRequired,
  setActiveTab: PropTypes.func.isRequired,
};

export default FormsTabNavigation;
